import { createSlice } from "@reduxjs/toolkit";

import {
  isLoggedInCases,
  setAuthUserReducer,
  setSignupPayloadReducer,
} from "./reducer";

const initialState = {
  isLoggedIn: false,
  authUser: null,
  signupPayload: {},
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthUser: setAuthUserReducer,
    setSignupPayload: setSignupPayloadReducer,
  },
  extraReducers: (builder) => {
    isLoggedInCases(builder);
  },
});

export const { setAuthUser, setSignupPayload } = authSlice.actions;

export default authSlice.reducer;
